import { ROUTES } from '~/lib/constants/routes'
import { contentPagesData } from '~/lib/content-pages'

export function useLinks() {
  const router = useRouter()
  const { t: $t } = useI18n()
  const localePath = useLocalePath()

  const homepageLink = computed(() => localePath('/'))
  const helpLink = computed(() => localePath(ROUTES.HELP_FAQ))
  const aboutLink = computed(() => localePath(ROUTES.ABOUT))
  const pricesLink = computed(() => localePath(ROUTES.PRICES))
  const howItWorksLink = computed(() => localePath(ROUTES.HOW_IT_WORKS))
  const reviewsLink = computed(() => localePath(ROUTES.REVIEWS))
  const eventDemoOrder = computed(() => localePath(ROUTES.EVENT_DEMO_ORDER))
  const contactLink = computed(() => localePath(ROUTES.CONTACT))
  const blogLink = computed(() => localePath(ROUTES.BLOG))
  const termAndConditionsLink = computed(() => localePath(ROUTES.TERMS_AND_CONDITIONS))
  const privacyPolicyLink = computed(() => localePath(ROUTES.PRIVACY_POLICY))

  const accountLink = computed(() => localePath(ROUTES.ACCOUNT))
  const accountHelpLink = computed(() => localePath(ROUTES.ACCOUNT_HELP))
  const accountEventsLink = computed(() => localePath(ROUTES.ACCOUNT_EVENTS))
  const accountUserLink = computed(() => localePath(ROUTES.ACCOUNT_USER))
  const accountOrdersLink = computed(() => localePath(ROUTES.ACCOUNT_ORDERS))

  const adminLink = computed(() => localePath(ROUTES.ADMIN))

  const weddingContentPageLink = computed(() => localePath(`/${getContentPageSlugById('wedding')}`))
  const birthdayContentPageLink = computed(() => localePath(`/${getContentPageSlugById('birthday')}`))
  const christmasContentPageLink = computed(() => localePath(`/${getContentPageSlugById('christmas')}`))
  const companyPartyContentPageLink = computed(() => localePath(`/${getContentPageSlugById('company_party')}`))
  const newYearsEveContentPageLink = computed(() => localePath(`/${getContentPageSlugById('new_years_eve')}`))
  const familyGatheringsContentPageLink = computed(() => localePath(`/${getContentPageSlugById('family_gatherings')}`))
  const sportsEventsContentPageLink = computed(() => localePath(`/${getContentPageSlugById('sports_events')}`))
  const vacationContentPageLink = computed(() => localePath(`/${getContentPageSlugById('vacation')}`))
  const weddingAnniversaryContentPageLink = computed(() =>
    localePath(`/${getContentPageSlugById('wedding_anniversary')}`),
  )

  const goToHomepage = function () {
    return router.push(homepageLink.value)
  }

  function goToAccountEventsOverviewPage() {
    return router.push(accountEventsLink.value)
  }

  const startOrder = function (query = {}) {
    return router.push({ path: localePath(ROUTES.EVENT_ORDER), query })
  }

  function getContentPageSlugById(id) {
    return $t(contentPagesData.find((item) => item.id === id).slug)
  }

  return {
    goToHomepage,
    startOrder,
    homepageLink,
    helpLink,
    aboutLink,
    pricesLink,
    howItWorksLink,
    reviewsLink,
    eventDemoOrder,
    contactLink,
    blogLink,
    termAndConditionsLink,
    privacyPolicyLink,

    goToAccountEventsOverviewPage,
    accountLink,
    accountHelpLink,
    accountEventsLink,
    accountUserLink,
    accountOrdersLink,

    adminLink,

    weddingContentPageLink,
    birthdayContentPageLink,
    christmasContentPageLink,
    companyPartyContentPageLink,
    newYearsEveContentPageLink,
    familyGatheringsContentPageLink,
    sportsEventsContentPageLink,
    vacationContentPageLink,
    weddingAnniversaryContentPageLink,
  }
}
